import { useTheme } from '@/lib/useTheme.js';
import './ThemeToggle.css';

/*
 * Three states rather than two, so "follow my system" stays reachable —
 * a plain on/off switch silently opts the user out of it forever.
 */
const OPTIONS = [
	{ id: 'light', label: 'Light', glyph: '☀' },
	{ id: 'dark', label: 'Dark', glyph: '☾' },
	{ id: 'system', label: 'System', glyph: '◐' },
];

export default function ThemeToggle() {
	const { theme, setTheme } = useTheme();

	return (
		<div className="theme-toggle" role="group" aria-label="Colour theme">
			{OPTIONS.map((option) => (
				<button
					key={option.id}
					type="button"
					className="theme-toggle__option"
					aria-pressed={theme === option.id}
					title={`${option.label} theme`}
					onClick={() => setTheme(option.id)}
				>
					<span aria-hidden="true">{option.glyph}</span>
					<span className="visually-hidden">{option.label} theme</span>
				</button>
			))}
		</div>
	);
}
